module.exports = __webpack_public_path__ + "img/selected5-min.43ff5647.png";